// extracted by mini-css-extract-plugin
export default {"screen_container":"Authentication_screen_container__G5oR+"};